import { render, staticRenderFns } from "./p404.vue?vue&type=template&id=4a3b1f67&scoped=true&"
import script from "./p404.vue?vue&type=script&lang=js&"
export * from "./p404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b1f67",
  null
  
)

export default component.exports